import {
  CommunicationEmailPreviewDto,
  CommunicationEmailsResponse,
  ResendEmailRequest,
  api,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const communicationApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getCommunicationEmails: builder.query<CommunicationEmailsResponse, number>({
      query: (examinerId) => api.communication.getEmails({ examinerId }),
      providesTags: ['Communication'],
    }),

    getCommunicationEmail: builder.query<CommunicationEmailPreviewDto, string>({
      query: (messageGuid) =>
        api.communication.getEmail({
          messageGuid,
        }),
      transformResponse: (response: { email: CommunicationEmailPreviewDto }) => response.email,
    }),

    resendCommunicationEmail: builder.mutation<void, ResendEmailRequest>({
      query: (request) => api.communication.resendEmail(request),
      invalidatesTags: ['Communication'],
    }),

    downloadCommunicationEml: builder.mutation<File, string>({
      query: (messageGuid) => api.communication.getEmailEml({ messageGuid }),
    }),
  }),
});

export const {
  useGetCommunicationEmailsQuery,
  useGetCommunicationEmailQuery,
  useResendCommunicationEmailMutation,
  useDownloadCommunicationEmlMutation,
} = communicationApi;
